// SearchType.jsx
'use strict';
import React from 'react';

import UniversalComponent from '../component/UniversalComponent.jsx';
import prepareSearchPageMeta from '../resource/prepareSearchPageMeta.js';
import { searchType } from '../resource/searchConstants.js';
import { createInitialStoreWithRequest } from '../createInitialStore.js';
import { generateLangPath, normalizeLang } from '../resource/langPath.js';

/**
 * Loader for search type pages
 * Generates SEO meta tags and JSON-LD for SearchResultsPage
 */
export const loader = async ({ request, params, language, i18nInstance }) => {
  const { type = searchType.ALL } = params;
  const url = new URL(request.url);
  const query = url.searchParams.get('q') || '';
  const hostname = url.hostname || 'swag.live';

  // Get Redux store
  const { store } = await createInitialStoreWithRequest({
    params,
    request,
  });
  const state = store.getState();
  const currentLanguage = normalizeLang(language);
  const langPath = generateLangPath(`/${currentLanguage}`, currentLanguage);

  // Build canonical URL
  const canonical = `https://${hostname}${langPath}/search/${type}${query ? `?q=${encodeURIComponent(query)}` : ''}`;

  // Prepare meta tags with JSON-LD
  const meta = await prepareSearchPageMeta({
    state,
    query,
    type,
    hostname,
    includeJsonLd: true,
    canonical,
    i18n: i18nInstance,
  });

  return {
    meta,
    params,
    staticContext: {
      requestHeaders: {
        hostname,
      },
    },
  };
};

const SearchTypeRoute = () => {
  return (
    <UniversalComponent
      filename="Container_Search"
      importer={/* #__LOADABLE__ */ () => import('../container/Search.js')}
    />
  );
};

export default SearchTypeRoute;
